import { VisitUsBtn } from "../styles/Buttons";
import { ContentWrapper, TextWrapper } from "../styles/Layouts";
import { Slogan, Subtitle, Title } from "../styles/Typography";

const Hero = () => {
  return (
    <ContentWrapper>
      <Title>hey, we are charcha:)</Title>
      <TextWrapper>
        <Subtitle>making coffee breaks tastier while sparking curiosity</Subtitle>
        <Slogan>freshly brewed coffee, ideas, art.</Slogan>
      </TextWrapper>

      <VisitUsBtn href="https://maps.app.goo.gl/We6mFy9Tk2vEgV9o7" target="_blank" rel="noopener noreferrer">
        VISIT US
      </VisitUsBtn>
    </ContentWrapper>
  );
};

export default Hero;
